/* global $ */

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['image'];

  connect() {
    if (this.data.get('edit') === 'true') {
      this.edit();
    } else {
      this.image = this.imageTarget.cloneNode(true);
      this.imageTarget.style.width = `${this.element.parentElement.offsetWidth}px`;
      this.view();
    }
  }

  disconnect() {
    if (this.data.get('edit') === 'true') return;
    if (!this.element.querySelector('.easypin')) return;

    this.element.appendChild(this.image);
    Array.from(this.element.querySelectorAll('.easypin')).forEach((el) => el.remove());
  }

  resize() {
    if (this.data.get('edit') === 'true') {
      return;
    }

    this.disconnect();
    this.connect();
    $(this.imageTarget).trigger('load');
  }

  edit() {
    this.instance = $(this.imageTarget).easypin({
      init: this.data.get('coordinates'),
      localStorage: false,
      modalWidth: 300,
      markerSrc: this.data.get('markerSrc'),
      editSrc: this.data.get('editSrc'),
      deleteSrc: this.data.get('removeSrc'),
      popoverStyle: {
        'line-height': 'inherit',
        padding: '5px',
      },
      popover: {
        element_id: (id) => JSON.parse(this.data.get('names'))[id] || 'TODO!',
      },
      done: (element) => Boolean(element.find('select').val()),
    });
  }

  view() {
    this.instance = $(this.imageTarget).easypinShow({
      data: this.data.get('coordinates'),
      responsive: false,
      variables: {
        element_id: (canvas_id, pin_id, id) => JSON.parse(this.data.get('names'))[id] || 'TODO!',
      },
      popover: {
        show: true,
        animate: true,
      },
      each: (index, data) => data,
      error: (e) => console.error(e),
      success: () => console.log(),
    });
  }
}
